module.exports = __webpack_public_path__ + "img/zhlc-1.07532eb6.png";